import { number, minValue, maxValue } from 'react-admin';

export const validInteger = (value, allValues) => {
  if ( ((''+value).indexOf('.'))>=0 || ((''+value).indexOf('.'))>=0 ) {
    return 'Must be valid integer.';
  }
  return [];
}

export const validMaxLineSeparated = (values, max) => {
  if (values?.split('\n').length > max) return `Cannot be more than ${max} entries`;
}

export const validFrequencyCap = [number(), minValue(0), validInteger];
export const validFrequencyHours = [number(), minValue(0), maxValue(168), validInteger];